import http from 'axios';

export default {
    state: {
        token: localStorage.getItem('at') || null,
        userRole: 'USER',
        userId: null,
        username: null,
    },
    getters: {
        isAuthorized: (state) => Boolean(state.token)
    },
    mutations: {
        SET_AUTH_DATA(state, { token, role, id, username }) {
            localStorage.setItem('at', token)
            state.token = token;
            state.userRole = role;
            state.userId = id;
            state.username = username;
        },
        removeAuthData(state) {
            localStorage.removeItem('at')
            state.token = null
        }
    },
    actions: {
        async loginUser({ commit }, { username, password }) {
            let { data } = await http.post('/api/auth/login', { username, password });
            commit('SET_AUTH_DATA', data)
        },
        async signOut({ commit }) {
            commit('removeAuthData')
            // Vue.prototype.$socket; 
        },
        async verifyToken({ commit, state }) {
            if (!state.token) throw new Error()
            const {data} = await http.get('/api/auth/token', {headers: {Authorization: state.token}})
            commit('SET_AUTH_DATA', {
                username: data.username,
                token: state.token,
                role: data.role,
                id: data._id,
            })
        }
    },
    namespaced: true
}